import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { messages } from '../../messages';
import style from '../../style.module.less';

const InvoiceNumberColumn = ({ invoiceId }) => {
  return <div className={style['item-cell']}>{invoiceId}</div>;
};

InvoiceNumberColumn.propTypes = {
  invoiceId: PropTypes.string.isRequired,
};

export default {
  getMessageDescriptor: () => <FormattedMessage {...messages.invoiceNumber} />,
  id: 'invoiceNumber',
  render: InvoiceNumberColumn,
};
